import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SlotDurationInput extends Component {
  static propTypes = {
    defaultValue: PropTypes.number,
    startDateName: PropTypes.string,
    endDateName: PropTypes.string,
    listenToDateTimeInputEvents: PropTypes.bool,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    defaultValue: 0,
    startDateName: 'event[start_date]',
    endDateName: 'event[end_date]',
    listenToDateTimeInputEvents: false,
  }

  constructor(props) {
    super(props);

    this.state = {
      slotCount: this.calcSlotCount(this.props.defaultValue),
      slotDuration: this.props.defaultValue,
    };
  }

  // If we ever start using this component outside of the Event page, we may
  // need to allow customization of the event-listener here and in handleChange
  componentDidMount() {
    $(document).on('datetimeinput:change', this.handleChange);
  }

  componentWillUnmount() {
    $(document).off('datetimeinput:change', this.handleChange);
  }

  isInt(value) {
    return !isNaN(value) && (function (x) { return (x | 0) === x; }(parseFloat(value)));
  }

  calcSlotCount(slotDuration, startT, endT) {
    const endTime = endT || $(this.getInputElement(this.props.endDateName)).val();
    const startTime = startT || $(this.getInputElement(this.props.startDateName)).val();

    if (endTime.length > 0 && startTime.length > 0 && this.isInt(slotDuration) && slotDuration >= 10) {
      return parseInt((new Date(endTime) - new Date(startTime)) / 1000 / 60 / slotDuration, 10);
    }
    return 0;
  }

  handleChange = (e, newTime, triggerName) => {
    const slotDuration = (this.isInt(e.target.value) ? e.target.value : this.state.slotDuration);
    let slotCount = this.state.slotCount;
    let startTime = $(this.getInputElement(this.props.startDateName)).val();
    let endTime = $(this.getInputElement(this.props.endDateName)).val();

    if (e.target.name === this.props.name) {
      slotCount = this.calcSlotCount(slotDuration, startTime, endTime);
    } else if (this.props.listenToDateTimeInputEvents) {
      if (triggerName === this.props.endDateName) {
        endTime = newTime;
      } else if (triggerName === this.props.startDateName) {
        startTime = newTime;
      } else { return; }

      if (endTime !== '' && startTime !== '') { slotCount = this.calcSlotCount(slotDuration, startTime, endTime); }
    }
    this.setState({ slotCount, slotDuration });
  }

  getInputElement = (name) => `input[name='${name}']`;

  render() {
    const slotCountstyle = (this.state.slotCount < 0 ? { color: 'red' } : {});
    return (
      <div>
        <input
          type="text"
          id={this.props.id}
          name={this.props.name}
          defaultValue={this.props.defaultValue}
          onChange={this.handleChange} />
        <span style={slotCountstyle}>{this.state.slotCount} slots</span>
      </div>
    );
  }
}
